import * as React from 'react';
import { Component, inject, deps, observer } from '../../lib/component';
import { Loading } from '../loading/loading';
import { AccountOrderDetails } from './order-details';
import { FormattedMessage } from 'react-intl';
import { AddRemoveCompat } from '../compat/add-remove-compat';
import { PlayButtonCompat } from '../compat/play-button-compat';
import {PageAccountOrderLicences} from '../page-account-order-licences';
import {ArtistSchema, ChannelSchema, OrderSchema, TrackSchema} from '../../types/schema';
import {noop} from '../../lib/noop';
import {style} from 'typestyle';
import {centerCenter} from 'csstips';
import {percent, px} from 'csx';

export interface AccountOrderProps {
  loading: boolean;
  order: OrderSchema;
  channels: Array<ChannelSchema>;
  isMobile: boolean;
}

@inject(deps) @observer
export class AccountOrder extends Component<AccountOrderProps> {
  render() {
    const {handleClickLink} = this.props.controller.ui;

    if (this.props.loading) return (
      <div className={AccountOrder.styles.loading}>
        <Loading />
      </div>
    );

    const props = {
      model: this.props,
      isMobile: this.props.isMobile,
      AddRemove: AddRemoveCompat,
      PlayButton: PlayButtonCompat,
      preload: this.props.controller.image.preloadImage,
      preloadWaveform: this.props.controller.image.preloadWaveformSvg,
      onClickLink: handleClickLink,
      onDownloadAudio: this.handleDownloadAudio,
      onAttribution: this.handleViewAttribution,
      onDownloadEULA: noop,
      analytics: this.props.controller.analytics
    };

    const { order, channels } = this.props;

    return (
      <div className={AccountOrder.styles.container}>
        <AccountOrderDetails order={order} channels={channels} />
        <FormattedMessage tagName="h3" id="account.order.licences.title" />
        <PageAccountOrderLicences {...props}/>
      </div>
    )
  }

  handleDownloadAudio = (licenceId: string) => {
    this.props.controller.modal.showDownloadModal(licenceId);
  };

  handleViewAttribution = (licenceId: string) => {
    this.props.controller.modal.showAttributionModal(licenceId);
  };

  static styles = {
    container: style({
      $nest: {
        '& h3': {
          margin: '40px 0 20px 0'
        }
      }
    }),
    loading: style({
      ...centerCenter,
      width: percent(100),
      height: px(120),
    })
  }
}